import { render, staticRenderFns } from "./ButtonComentariosValidacion.vue?vue&type=template&id=4e03efc4"
import script from "./ButtonComentariosValidacion.vue?vue&type=script&lang=js"
export * from "./ButtonComentariosValidacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports